export function hasInsightItems(items: { count: number }[]): boolean {
  return items.some((item) => item.count > 0);
}
